import { apiFetch, tokenStore } from './client';

export interface AuthUser {
  id: string;
  email: string;
  name?: string | null;
  role: 'USER' | 'ADMIN' | 'SUPER_ADMIN';
  avatar?: string | null;
  googleId?: string | null;
  phone?: string | null;
  cpf?: string | null;
  hasPassword?: boolean;
  profileComplete?: boolean;
  createdAt: string;
}

interface AuthResponse {
  user: AuthUser;
  accessToken: string;
}

export const authApi = {
  register: async (email: string, password: string, name?: string): Promise<AuthResponse> => {
    const data = await apiFetch<AuthResponse>('/auth/register', {
      method: 'POST',
      body: { email, password, name },
      skipAuth: true,
    });
    tokenStore.set(data.accessToken, data.user);
    return data;
  },

  login: async (email: string, password: string): Promise<AuthResponse> => {
    const data = await apiFetch<AuthResponse>('/auth/login', {
      method: 'POST',
      body: { email, password },
      skipAuth: true,
    });
    tokenStore.set(data.accessToken, data.user);
    return data;
  },

  logout: async () => {
    try {
      await apiFetch('/auth/logout', { method: 'POST' });
    } finally {
      tokenStore.clear();
    }
  },

  me: () => apiFetch<AuthUser>('/auth/me'),
};
